import { orchestrator } from 'satcheljs';
import { deleteEmail } from '../services/deleteEmail';
import { getPremiumUser } from '../actions/getPremiumUser';
import { removeEmail } from '../actions/removeEmail';
import setIsRemovingEmailAddress from '../mutators/setIsRemovingEmailAddress';

export default orchestrator(removeEmail, async function removeEmail() {
    setIsRemovingEmailAddress(true);
    await deleteEmail();
    await getPremiumUser();
    setIsRemovingEmailAddress(false);
});
